/**
 * Sistema de logging estruturado para OptiSaaS
 * Substitui console.log em produção para evitar vazamento de informações
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogEntry {
  timestamp: string;
  level: LogLevel;
  module: string;
  message: string;
  data?: unknown;
}

const isDevelopment = import.meta.env.DEV;

const formatLogEntry = (entry: LogEntry): string => {
  const time = new Date(entry.timestamp).toISOString();
  const dataStr = entry.data ? ` ${JSON.stringify(entry.data)}` : '';
  return `[${time}] [${entry.level.toUpperCase()}] [${entry.module}] ${entry.message}${dataStr}`;
};

const log = (level: LogLevel, module: string, message: string, data?: unknown) => {
  // Em produção, apenas logs de erro são registrados
  if (!isDevelopment && level === 'debug') return;
  if (!isDevelopment && level === 'info') return;

  const entry: LogEntry = {
    timestamp: new Date().toISOString(),
    level,
    module,
    message,
    data,
  };

  const formattedMessage = formatLogEntry(entry);

  switch (level) {
    case 'debug':
      console.log(formattedMessage);
      break;
    case 'info':
      console.info(formattedMessage);
      break;
    case 'warn':
      console.warn(formattedMessage);
      break;
    case 'error':
      console.error(formattedMessage);
      break;
  }

  // Em produção, enviar erros para serviço de monitoramento (ex: Sentry)
  if (!isDevelopment && level === 'error') {
    // TODO: Integrar com Sentry ou similar
    // Sentry.captureException(new Error(message), { extra: { module, data } });
  }
};

export const logger = {
  debug: (module: string, message: string, data?: unknown) => log('debug', module, message, data),
  info: (module: string, message: string, data?: unknown) => log('info', module, message, data),
  warn: (module: string, message: string, data?: unknown) => log('warn', module, message, data),
  error: (module: string, message: string, data?: unknown) => log('error', module, message, data),
};
